import React from 'react';
import { useTranslation } from 'react-i18next';
import ScrollArea from '../../../components/atoms/ScrollArea/ScrollArea';
import { ContentList, ContentListItem } from '../ContentList';
import { RefreshCallback } from '../../BlockFetcher';
import { DeletableItem } from './partials/DeletableItem';
import ContentMessage from '../ContentMessage/ContentMessage';
import { SonForm } from '../../Form2';

type DeletableItem = {
  id: string;
  name?: string;
  removeForm: SonForm<any>;
};

type DeletableItemListProps<T> = {
  children(item: T): React.ReactNode;
  items: T[];
  refresh?: RefreshCallback;
  namespaceAndKey: string;
};

export function DeletableItemList<T extends DeletableItem>({
  namespaceAndKey,
  items,
  children,
  refresh,
}: DeletableItemListProps<T>) {
  const { t } = useTranslation();

  if (items?.length === 0) {
    return <ContentMessage text={t(`${namespaceAndKey}.noContent`)} />;
  }

  // list with websocket connections -> no need for manual refreshing
  // only use if refresh function is given.

  return (
    <ScrollArea to={100} bottomOffset={10}>
      <div className="deletable-item-list">
        <ContentList ordered>
          {items.map((item, index) => {
            return (
              <ContentListItem key={item.id}>
                <DeletableItem
                  id={item.id}
                  name={item.name}
                  namespace={namespaceAndKey}
                  position={index + 1}
                  numberOfItems={items.length}
                  removeForm={item.removeForm}
                  refresh={refresh}
                >
                  {children(item)}
                </DeletableItem>
              </ContentListItem>
            );
          })}
        </ContentList>
      </div>
    </ScrollArea>
  );
}
